import { MOBILE_WINDOW_WIDTH } from '@app/core/constants/window';

export const isMobileWindowWidth = (): boolean => {
  return window.innerWidth <= MOBILE_WINDOW_WIDTH;
};

export const scrollToTop = (): void => {
  window.scrollTo({
    top: 0,
    left: 0,
    behavior: 'instant',
  });
};
